/**
 * Enum representing the status of a payment transaction for an order.
 */
export enum OrderPaymentTransactionStatus {
    Approved = 1,
    Pending = 2,
    Declined = 3,
    Voided = 4,
    Refunded = 5,
    Confirmed = 6,
    Failed = 7,
    Unknown = 8,
}

export const OrderPaymentTransactionStatusLabelMapping: Record<
    OrderPaymentTransactionStatus,
    string
> = {
    [OrderPaymentTransactionStatus.Approved]: 'Payment Approved',
    [OrderPaymentTransactionStatus.Pending]: 'Awaiting Confirmation',
    [OrderPaymentTransactionStatus.Declined]: 'Payment Declined',
    [OrderPaymentTransactionStatus.Voided]: 'Payment Voided',
    [OrderPaymentTransactionStatus.Refunded]: 'Payment Refunded',
    [OrderPaymentTransactionStatus.Confirmed]: 'Payment Confirmed',
    [OrderPaymentTransactionStatus.Failed]: 'Payment Failed',
    [OrderPaymentTransactionStatus.Unknown]: 'Payment Unknown',
};
